/**
 * Заглушка для клиентских расширений (клиент не выбран).
 * Когда в currentclient.txt указан клиент (например, "gj"),
 * симлинк client → clients/gj заменяет этот файл.
 */
export const CLIENT_COMPONENTS: any[] = [];
export const CLIENT_PROVIDERS: any[] = [];
export const CUSTOM_LOGIN_COMPONENT = null;
export const HAS_CUSTOM_LOGIN = false;

